const InvoiceRow = ({ item, isChecked, onRowSelect }) => (
    <tr>
      <td className="border px-4 py-2 text-center">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={(e) => onRowSelect(e.target.checked)}
        />
      </td>
      <td className="border px-4 py-2">{item.VBELN}</td>
      <td className="border px-4 py-2">{item.FKDAT}</td>
      <td className="border px-4 py-2">{item.ZNAME1}</td>
      <td className="border px-4 py-2">{item.NAME1}</td>
      <td className="border px-4 py-2">{item.WAERK}</td>
      <td className="border px-4 py-2 text-right">{item.NETWR}</td>
    </tr>
  );
  
  export default InvoiceRow;
  